import styled from "styled-components";
import Layout_user from "../../../Component/UI/Layout_user";
import { Icon } from "../../../Component/style/common_style";
import { useNavigate } from "react-router-dom";
import TopBar from "../../../Component/UI/TopBar";
import WithdrawModal from "./Modal/WithdrawModal";
import { useState } from "react";
import Footer from "../../../Component/UI/Footer";
import api from "../../../Component/axios_Interceptor/api";
import url from "../../../Component/server";
import { useEffect } from "react";
import { subscribeSupportActivity } from "../../../Component/Support/supportRealtime";

const Help = () => {
  const navigate = useNavigate();
  const refreshToken = (localStorage.getItem("key") || sessionStorage.getItem("key")) || null;
  const [withdrawModalVisible, setWithdrawModalVisible] = useState(false);
  const [unreadCounts, setUnreadCounts] = useState({ platform: 0, seller: 0 });
  const [unreadError, setUnreadError] = useState(false);
  const [unreadRetry, setUnreadRetry] = useState(0);
  const [accountLevel, setAccountLevel] = useState<"loading" | "normal" | "master" | "other" | "guest" | "error">(refreshToken ? "loading" : "guest");
  const handleWithdrawModal = () => {
    setWithdrawModalVisible(!withdrawModalVisible);
  };

  useEffect(() => {
    if (!refreshToken) return;
    let active = true;
    api.get(url.Communication_url.user_info).then(response => {
      if (!active) return;
      const level = response.data?.user_level;
      setAccountLevel(level === "normal" ? "normal" : level === "master" ? "master" : "other");
    }).catch(() => { if (active) setAccountLevel("error"); });
    return () => { active = false; };
  }, [refreshToken]);

  useEffect(() => {
    if (!refreshToken) {
      setUnreadCounts({ platform: 0, seller: 0 });
      setUnreadError(false);
      return;
    }
    let active = true;
    let latestRequest = 0;
    const loadUnread = async () => {
      const request = ++latestRequest;
      try {
        const response = await api.get(url.Communication_url.support_conversations, { timeout: 10000 });
        if (!active || request !== latestRequest) return;
        const items = response.data?.items;
        if (!Array.isArray(items)) throw new Error("Invalid conversations");
        const counts = { platform: 0, seller: 0 };
        for (const item of items) {
          const count = Number(item?.unread_count);
          if (!item || !["platform", "seller"].includes(item.channel) || !Number.isSafeInteger(count) || count < 0) {
            throw new Error("Invalid unread count");
          }
          counts[item.channel as keyof typeof counts] += count;
        }
        setUnreadCounts(counts);
        setUnreadError(false);
      } catch {
        if (active && request === latestRequest) setUnreadError(true);
      }
    };
    void loadUnread();
    const unsubscribe = subscribeSupportActivity(() => { void loadUnread(); });
    return () => { active = false; unsubscribe(); };
  }, [refreshToken, unreadRetry]);

  return (
    <Layout_user>
      <HelpPage>
      <TopBar title={"고객센터"} />
      <MenuListDiv>
        <MenuItem type="button" onClick={() => navigate("/support/platform")}>
          <MenuText>
            <strong>플랫폼 관리자 문의{unreadCounts.platform > 0 && <UnreadBadge aria-label={`읽지 않은 플랫폼 관리자 상담 메시지 ${unreadCounts.platform}개`}>{unreadCounts.platform > 99 ? "99+" : unreadCounts.platform}</UnreadBadge>}</strong>
            <span>팬버드 이용 및 결제 관련 상담</span>
          </MenuText>
          <span aria-hidden="true">›</span>
        </MenuItem>
        <MenuItem type="button" onClick={() => navigate("/support/sellers")}>
          <MenuText>
            <strong>셀러 문의{unreadCounts.seller > 0 && <UnreadBadge aria-label={`읽지 않은 셀러 상담 메시지 ${unreadCounts.seller}개`}>{unreadCounts.seller > 99 ? "99+" : unreadCounts.seller}</UnreadBadge>}</strong>
            <span>상품, 배송 및 주문 관련 상담 내역</span>
          </MenuText>
          <span aria-hidden="true">›</span>
        </MenuItem>
        {accountLevel === "normal" && (
          <MenuItem type="button" onClick={handleWithdrawModal}>
            <Icon
              src={require("../../../Image/ic_people_white.png")}
              style={{ marginRight: 5, filter: "var(--user-icon-filter)" }}
            />
            <MenuText><strong>회원탈퇴</strong></MenuText>
          </MenuItem>
        )}
        {accountLevel === "master" && (
          <MenuItem type="button" onClick={() => navigate("/support/platform")}>
            <MenuText><strong>셀러 계정 해지 문의</strong><span>진행 중인 주문과 정산 확인 후 플랫폼 관리자가 처리합니다.</span></MenuText>
            <span aria-hidden="true">›</span>
          </MenuItem>
        )}
        {unreadError && <UnreadState role="alert">새 답변 수를 확인하지 못했습니다. <button type="button" onClick={() => setUnreadRetry(value => value + 1)}>다시 확인</button></UnreadState>}
        {accountLevel === "error" && <AccountState role="alert">회원 유형을 확인하지 못해 탈퇴 메뉴를 표시할 수 없습니다. 잠시 후 다시 시도해 주세요.</AccountState>}
      </MenuListDiv>
      <WithdrawModal
        visible={withdrawModalVisible}
        handleModal={handleWithdrawModal}
      />
      <Footer />
    </HelpPage>
    </Layout_user>
  );
};
export default Help;

const HelpPage = styled.div`
  display: flex;
  flex-direction: column;
  min-height: var(--browser-layout-height, 100dvh);
`;

const MenuListDiv = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1 0 auto;
  padding: 20px;
  box-sizing: border-box;
  font-family: var(--font-Pretendard-SemiBold);
  font-size: 16px;
`;

const MenuItem = styled.button`
  width: 100%;
  min-height: 72px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 0;
  border-bottom: 1px solid var(--user-border);
  padding: 14px 0;
  color: var(--user-text);
  background: transparent;
  text-align: left;
  cursor: pointer;
`;

const MenuText = styled.span`
  display: flex;
  flex-direction: column;
  gap: 5px;
  strong { display: inline-flex; align-items: center; gap: 8px; font-size: 16px; font-family: var(--font-Pretendard-SemiBold); }
  > span { color: var(--user-text-muted); font-size: 13px; font-family: var(--font-Pretendard-Regular); }
`;

const AccountState = styled.p`
  margin: 16px 0 0;
  padding: 14px;
  border-radius: 8px;
  background: var(--user-error-soft);
  color: var(--user-error);
  font-size: 14px;
  line-height: 1.5;
`;

const UnreadBadge = styled.span`
  min-width: 20px;
  height: 20px;
  padding: 0 5px;
  box-sizing: border-box;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: #d92d20;
  color: #fff;
  font-size: 12px;
  font-family: var(--font-Pretendard-SemiBold);
`;

const UnreadState = styled.p`
  margin: 16px 0 0;
  color: var(--user-text-muted);
  font-size: 13px;
  line-height: 1.5;
  button {
    min-height: 44px;
    padding: 0 8px;
    border: 0;
    background: transparent;
    color: var(--user-accent);
    font: inherit;
    text-decoration: underline;
    cursor: pointer;
  }
  button:focus-visible { outline: 2px solid var(--user-accent); outline-offset: 2px; }
`;
